/* eslint-disable */
import $ from 'jquery';

export default {
    init() {
        $(document).ready(function(){
            $('.wrap').css('padding','0');
        })
    },
    finalize() {
        var domain = -1;
        var maxDomain = 7;
        var score = 0;
        $(document).ready(function(){
            load_tip(domain);

            //reload datas when a new self audit starts
            sessionStorage.setItem('score',0)
            for(var i = 0; i<7; i++){
                sessionStorage.removeItem(i);
            }
            sessionStorage.removeItem('id');

            CalculScore(0)
            init_click(domain);
            navigationBetweenDomain(domain)
        })

        
        $(document).on('click', '.tip_action', function(){
            $('#block_tip').toggleClass('open')
        });

        
        function navigationBetweenDomain(domain){
            $(document).on('click', '.domain', function(){
                var domain = $(this).attr('id');
                load_domain(domain)
                domain = parseInt(domain)
            })
        }

        function init_click(domain){
            $('.next').click(function(){
                $('#loader').show()
                domain = parseInt(domain)+1
                save_data(domain)
                load_domain(domain)
                load_tip(domain)
            })
            $('.item_choice').on('click', function(){
                //on regarde si c'est le 1er qui est cliqué
                var firstActive = true;
                $('.item_choice').each(function(){
                    if($(this).hasClass('active')){
                        firstActive = false;
                    }
                })

                //on incrémente le score en fonction des autres ou non.
                if($(this).hasClass('item_unique')){
                    if(!firstActive && $(this).hasClass('active')){
                        CalculScore(-$(this).attr('data-score'))
                    } else if(firstActive && !$(this).hasClass('active')) {
                        CalculScore($(this).attr('data-score'))
                    }
                } else {
                    if($(this).hasClass('active')){
                        CalculScore(-$(this).attr('data-score'))
                    } else {
                        CalculScore($(this).attr('data-score'))
                    }
                }
                if($(this).hasClass('item_unique')){
                    $('.item_choice').not(this).removeClass('active')
                }
                $(this).toggleClass('active')
            })
        }

        function CalculScore(toMove){
            var toMove = parseInt(toMove)
            if(sessionStorage.getItem('score')){
                score = parseInt(sessionStorage.getItem('score')) + toMove
                sessionStorage.setItem('score', score)
            } else {
                score = toMove
                sessionStorage.setItem('score', score)
            }
        }

        function save_data(domain){
            var answers = []
            if(domain != 8){
                $('.item_choice').each(function(){
                    if($(this).hasClass('active')){
                        answers.push($(this).attr('id'))
                    }
                })
            } else {
                answers.push($('#company_size').val())
            }
            if(!sessionStorage.getItem('id')){
                var id = ""
            } else {
                var id = sessionStorage.getItem('id')
            }
            sessionStorage.setItem(domain, answers);
            
            $.ajax({
                data: {
                    action: 'save_datas',
                    domain: domain,
                    answers: answers,
                    id: id
                },
                method : 'POST',
                url : ajaxObject.ajaxurl,
                success: function(response){
                    sessionStorage.setItem('id', response);
                }
            })
        }


        function load_tip(domain){
            
            $.ajax({
                data: {
                    action: 'get_random_tip',
                    domain: domain
                },
                method : 'POST',
                url : ajaxObject.ajaxurl,
                success: function(response){
                    $('.single_tip').html(response)
                }
            })
        }

        function load_domain(domain){
            var industry = true;
            if(sessionStorage.getItem('2')){ 
                if(sessionStorage.getItem('2') == '1590'){
                    // 1590 pour la prod 
                    // 879 pour la beta
                    var industry = false;
                } else {
                    var industry = true
                }
            }
            //Pas encore de réponse Internally / Externally ou a répondu Internally
            if(sessionStorage.getItem('6')){ 
                if(sessionStorage.getItem('6') != '1605' && sessionStorage.getItem('6') != '1603'){//1605 pour la prod
                    var company = false;
                } else {
                    var company = true;
                    if(sessionStorage.getItem('6') != '1603'){ //UNIQUEMENT POUR COMPANY = EXTERNALLY
                        if(sessionStorage.getItem('7')){
                            sessionStorage.removeItem('7');
                        }                    
                        if(domain == 6){
                            //goes to last question
                            domain = domain+1;
                        }
                    } else {
                        console.log('externe et interne')
                    }
                }
            } else {
                var company = false;
            }

            if(domain == 6){
                var ids = sessionStorage.getItem('1');
            } else {
                var ids = "";
            }
                       
            $.ajax({
                data: {
                    action: 'get_datas',
                    domain: domain,
                    company: company,
                    industry: industry,
                    authorized: ids
                },
                method : 'POST',
                url : ajaxObject.ajaxurl,
                success: function(response){
                    if(domain > maxDomain){
                        //end of form
                        window.location.href = window.location+"/self-audit/self-audit-results"
                    } else if(domain == 7 && sessionStorage.getItem('6') == '1604'){ 
                        //end of form (no company question)
                        window.location.href = window.location+"/self-audit/self-audit-results"
                    } else {
                        //adjust progress bar
                        var width = domain*100/maxDomain
                        $('.progress').css('width', width+'%')
                        $('.left_part').html(response)
                        init_click(domain);
                        retrieve_datas_from_session()
                    } 
                    if(domain == 0){
                        $('.left_part').removeClass('xl:col-span-6 xl:col-start-3')
                        $('.left_part').addClass('xl:col-span-8 xl:col-start-2')
                        $('.progressbar').show()
                        $('.back').show()
                        $('.center_action').removeClass('items-center').addClass('lg:pt-32')
                    }

                    //retrieve data from session storage
                    if(domain != 7){
                        if(sessionStorage.getItem(parseInt(domain)+1)){
                            var historics = sessionStorage.getItem(parseInt(domain)+1);
                            historics.split(',')
                            $('.item_choice').each(function(){
                                if(historics.indexOf($(this).attr('id')) != -1){
                                    $(this).addClass('active')
                                }
                            })
                        }
                    }

                    //company: init range slider
                    if(domain == 7){
                        rangeSlider()
                    }
                    
                }
            })

        }


        function retrieve_datas_from_session(){
            var datas = [];
            for(let i = 1; i < 8; i++){
                if(sessionStorage.getItem(i)){
                    var dataDomain = [i, sessionStorage.getItem(i)]
                    datas.push(dataDomain)
                }
            }
            if(datas){
                $.ajax({
                    data: {
                        action: 'retrieve_datas_from_session',
                        datas: datas
                    },
                    method : 'POST',
                    url : ajaxObject.ajaxurl,
                    success: function(response){
                        var datas = JSON.parse(response)
                        $.each(datas, function(key, value){
                            var insert = value.join(' · ');
                            $('#dynamic-value-'+key).find('.text').append(insert)
                        })        
                    }
                })
            }
        }

        function rangeSlider() {
            $('.range-slider__range').on("change mousemove", function(){
                $('.range-slider__value').text($(this).val());
                if($(this).val() == 1000){
                    $('.range_text_before').text('')
                    $('.range_text_after').text('or more')
                } else {
                    $('.range_text_before').text('Up to')
                    $('.range_text_after').text('')

                }
            });
        };
          
        
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/self-audit.js